import React from 'react';
import GlobalPresence from '../components/GlobalPresence';
import ContactForm from '../components/ContactForm';
import ContactAndMapPage from '../components/ContactAndMapPage';




export default function ContactPage() {
  return (
    // Use a <main> tag or a Fragment <> to group the components
    <main>
     
     {/* <ContactForm />
     <GlobalPresence /> */}
     <ContactAndMapPage />
    </main>
  );
}